import { render, staticRenderFns } from "./DialogListBotByUser.vue?vue&type=template&id=2db40a28&scoped=true"
import script from "./DialogListBotByUser.vue?vue&type=script&lang=js"
export * from "./DialogListBotByUser.vue?vue&type=script&lang=js"
import style0 from "./DialogListBotByUser.vue?vue&type=style&index=0&id=2db40a28&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db40a28",
  null
  
)

export default component.exports